import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import ReschedulePage from './ReschedulePage.js';

export default WithGASetup(ReschedulePage, AuthContext);
